import { t } from 'ttag'
import { useDispatch, useSelector } from 'react-redux'

import ComparisonFooter from '@main/components/ComparisonFooter'
import { Grid } from '@h2/components/containers/grid'
import { setForComparison } from '@main/actions/occupationProfile'
import { Link } from '@h2/common/components/link'

const SimilarOccupations = ({ relatedOnet, occupationMeta }) => {
  const { jobZoneValues } = useSelector(state => state.jobZones)
  const dispatch = useDispatch()
  const handleRowSelect = selectedValue => {
    dispatch(setForComparison(selectedValue.map(occ => occ.cipCode)))
  }
  const columns = [
    {
      id: 'title',
      label: t`Title`,
      width: '80%',
      sortable: false,
      render({ onetSoc, url, title }) {
        return (
          <>
            <Link href={url}>{title}</Link>
            {occupationMeta.inBudget[onetSoc] && (
              <span
                className="badge listing-badge budget defined"
                title={t`This occupation would satisfy the salary requirements from your budget.`}>
                <span>{t`In Budget`}</span>
              </span>
            )}
            {(occupationMeta.flags[onetSoc] || []).map((flag, idx) => (
              <span
                key={`flag-${idx}`}
                className={`badge listing-badge ${flag.styleClass} defined`}
                title={flag.description}>
                <span>{flag.name}</span>
              </span>
            ))}
          </>
        )
      }
    },
    {
      id: 'jobZone',
      label: t`JobZone`,
      sortable: false,
      render({ jobZone }) {
        const jz = jobZoneValues[jobZone] || {}

        return (
          <div className="job-zone" title={jz.description}>
            {jobZone}
          </div>
        )
      }
    }
  ]

  return (
    <>
      {relatedOnet.length === 0 ? null : (
        <Grid
          columns={columns}
          data={relatedOnet}
          defaultSortBy="title"
          onSelectRow={handleRowSelect}
          options={{ disableFilters: true, fullWidth: true }}
          rowIdKey="onetSoc"
          isPagerVisible={false}
          isRowSelectable={true}
        />
      )}
      <ComparisonFooter />
    </>
  )
}

export { SimilarOccupations }
